/*
loader
------------------------------------------------------------------*/


//$('.template-index .loader').append('<img class="touchicon" src="https://cdn.shopify.com/s/files/1/0548/9203/6257/t/5/assets/loading_500x.png">').fadeIn(150);
  
$(window).on('load', function(){
  stopload();
});
setTimeout('stopload()',10000);

function stopload(){
    if($('body').hasClass('template-index')){
        $('.loader-bg').delay(1300).fadeOut(800);
        $('.loader').delay(1000).fadeOut(300); 
      
    }else{
        $('.loader-bg').fadeOut(300);
        $('.loader').fadeOut(200);
      	console.log('トップじゃない');
    }
}



/*
IOS判別
------------------------------------------------------------------*/

if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
      $("body").addClass('mobile-device');
}else if (navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0){
      $("body").addClass('mobile-device');
}else if (navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') == -1 && typeof document.ontouchstart !== 'undefined') {
      $("body").addClass('mobile-device');
}else{
      $("body").addClass('pc-device');
}
         


/*
swipe icon
------------------------------------------------------------------*/

$('.wrap_scroll').append('<img class="touchicon" src="https://cdn.shopify.com/s/files/1/0548/9203/6257/t/5/assets/icon_swipe.png">');


$('.wrap_scroll img').on('touchmove', function(e) {
    $('.wrap_scroll .touchicon').fadeOut('fast');
});